import { DragDropContext, Droppable } from 'react-beautiful-dnd'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { movePoint } from '../../state/path/path.actions'
import { selectPath } from '../../state/path/path.selectors'
import { setActivePoint, setDraggedPoint } from '../../state/ui/ui.actions'
import { RouteListItem } from './route-list-item/route-list-item.component'
import { RouteListStyled } from './route-list.styled'

const RouteListComponent = (props: any) => {
  const handleOnDragEnd = (result: any) => {
    result.source &&
      result.destination &&
      props.movePoint([result.source.index, result.destination.index])
    props.setActive(undefined)
    props.setDragged(undefined)
  }

  const handleOnDragUpdate = (result: any) => {
    result.source?.index && props.setActive(result.source.index)
    props.setDragged(result.source.index)
  }

  return (
    <RouteListStyled>
      <DragDropContext
        onDragEnd={handleOnDragEnd}
        onDragUpdate={handleOnDragUpdate}
        {...props}
      >
        <Droppable droppableId='route-list'>
          {(provided) => (
            <ul {...provided.droppableProps} ref={provided.innerRef}>
              {(props.path || []).map((point: any, i: number) => (
                <RouteListItem
                  coordinate={point}
                  index={i}
                  length={props.path?.length}
                />
              ))}
              {provided.placeholder}
            </ul>
          )}
        </Droppable>
      </DragDropContext>
    </RouteListStyled>
  )
}

const stateProps = createStructuredSelector({
  path: selectPath,
})

const dispatchProps = {
  movePoint: movePoint,
  setActive: setActivePoint,
  setDragged: setDraggedPoint,
}

export const RouteList = connect(stateProps, dispatchProps)(RouteListComponent)
